import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Segment, Header, Form, Loader} from 'semantic-ui-react';
import {
  Checkbox,
  TextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Alert} from 'componentLibrary';
import ReactHtmlParser from 'react-html-parser';
import REST from 'go/requests/rest';
import _ from 'lodash';
import {BurdenStatement} from './BurdenStatement';
import {BURDEN_STATEMENTS} from './BurdenStatementTemplates';
import ButtonField from 'app-ui-componentlibrary/dist/go/components/common/form/ButtonField';
import {produce} from 'immer';
import {isLoginGovUser} from 'common/utils';

export class DynamicAssuranceAndCertifications extends React.Component {
  state = {
    loading: true,
    successArr: [],
    passwordArr: [],
    errorArr: [],
    confirmationArr: [],
  };

  componentDidMount = () => this.refreshData();
  componentDidUpdate = (prevProps) => {
    const {grantId, fundingOpportunityId, saveEntitySessionData, entityDataPath, data} =
      this.props;
    if (
      !_.isEqual(grantId, _.get(prevProps, 'grantId')) ||
      !_.isEqual(fundingOpportunityId, _.get(prevProps, 'fundingOpportunityId'))
    ) {
      this.refreshData();
    }

    const {successArr, numberOfAssurances} = this.state;
    let numberOfSuccess = 0;
    _.forEach(successArr, (succ) => {
      if (succ) {
        numberOfSuccess++;
      }
    });
    if (
      numberOfAssurances !== undefined &&
      numberOfAssurances === numberOfSuccess &&
      data !== true
    ) {
      saveEntitySessionData(entityDataPath, true);
    }
  };

  fetchRules = () => {
    const {
      grantId,
      fundingOpportunityId,
      token,
      rulePayload,
      saveEntitySessionData,
      entityDataPath,
    } = this.props;

    let fetchRulePromise;
    if (rulePayload) {
      if (rulePayload.resetValidations) {
        saveEntitySessionData(entityDataPath, false);
      }
      let payload = {};
      _.each(rulePayload, (value, key) => {
        payload[key] = _.get(this.props, value);
      });
      if (
        payload.configId == null &&
        this.props.templatePayload &&
        this.props.templatePayload.categoryId
      )
        payload['configId'] = this.props.templatePayload.categoryId;
      fetchRulePromise = REST.rules.getRulesByPayload(token, payload);
    } else if (token && grantId && fundingOpportunityId) {
      fetchRulePromise = REST.rules.getRulesByRuleSet(
        token,
        grantId,
        fundingOpportunityId,
        'assurancesCertifications'
      );
    } else {
      fetchRulePromise = Promise.reject('Error: Not enough data to fetch rules');
    }
    return fetchRulePromise;
  };

  constructTemplateUrl = () => {
    const {grantId, fundingOpportunityId, templatePayload} = this.props;

    if (templatePayload) {
      let params = [];
      _.each(templatePayload, (value, key) => {
        params.push(`${key}=${_.get(this.props, value, value)}`);
      });
      return _.join(params, '&');
    }
    return `grantId=${grantId}&fundingOpportunityId=${fundingOpportunityId}`;
  };

  refreshData() {
    const {token, isHidden} = this.props;

    if (token && !isHidden) {
      this.fetchRules()
        .then(REST.handler.handleResponse)
        .then((response) => {
          this.setState({config: response.payload});
          let rulesAC = _.flatMapDeep(response);
          let allTitles = [];

          var templateStringPath = '?';
          _.forEach(rulesAC, (rule) => {
            templateStringPath = templateStringPath + 'templateName=' + rule.title + '&';
            allTitles.push(rule.title);
          });
          templateStringPath = templateStringPath + this.constructTemplateUrl();
          REST.template
            .getTemplate(token, templateStringPath)
            .then(REST.handler.handleResponse)
            .then((response) => {
              const dataToRender = _.flatMap(response.templates);
              const numberOfAssurances = _.size(dataToRender);
              this.setState({
                loading: false,
                dataToRender,
                allTitles,
                passwordArr: new Array(numberOfAssurances).fill().map((item, idx) => ''),
                confirmationArr: new Array(numberOfAssurances)
                  .fill()
                  .map((item, idx) => false),
                successArr: new Array(numberOfAssurances)
                  .fill()
                  .map((item, idx) => false),
                numberOfAssurances,
              });
            });
        })
        .catch((error) => console.log(error));
    }
  }

  passwordConfirmation = (index) => {
    const {confirmationArr, passwordArr, errorArr, successArr} = this.state;
    const {label, username} = this.props;
    const success = _.get(successArr, index);
    const error = _.get(errorArr, index);
    const password = _.get(passwordArr, index);
    const confirmation = _.get(confirmationArr, index);
    const showAssuranceAuth =
      _.get(this.props, 'showAssuranceAuth') !== undefined
        ? _.get(this.props, 'showAssuranceAuth')
        : true;

    const handleChange = (name, value) => {
      this.setState(
        produce(this.state, (draft) => {
          _.set(draft, name, value);
          _.set(draft, ['errorArr', index], false);
        })
      );
    };
    const handleClick = () => {
      REST.auth.authLogin(username, password).then((res) => {
        if (res.status === 200) {
          this.setState({
            successArr: produce(successArr, (draft) => {
              draft[index] = true;
            }),
          });
        } else {
          this.setState({
            errorArr: produce(errorArr, (draft) => {
              draft[index] = true;
            }),
          });
        }
      });
    };

    if (showAssuranceAuth) {
      let loginGovIntegration = isLoginGovUser();

      let handleChangeLoginGov = () => {
        this.setState({
          successArr: produce(successArr, (draft) => {
            draft[index] = true;
          }),
          confirmationArr: produce(confirmationArr, (draft) => {
            draft[index] = true;
          }),
          errorArr: produce(errorArr, (draft) => {
            draft[index] = false;
          }),
        });
      };
      return loginGovIntegration ? (
        <React.Fragment>
          <Checkbox
            label={label}
            checked={confirmation}
            name={`confirmationArr.${index}`}
            handleChange={() => handleChangeLoginGov()}
            disabled={success}
          />
          {success ? (
            <Alert alertType="success" header={'Signature accepted'}>
              <p>Your signature for this assurance has been accepted.</p>
            </Alert>
          ) : (
            <></>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Checkbox
            label={label}
            checked={_.get(confirmation, index)}
            name={`confirmationArr.${index}`}
            handleChange={(name) => handleChange(name, !confirmation)}
            disabled={success}
          />
          {success ? (
            <Alert alertType="success" header={'Signature accepted'}>
              <p>Your signature for this assurance has been accepted.</p>
            </Alert>
          ) : (
            <React.Fragment>
              <TextBoxField
                id="password"
                name={`passwordArr.${index}`}
                value={password}
                handleChange={(e, data) => handleChange(data.name, data.value)}
                title="Password"
                type="password"
                size="small"
                label="Please enter your password."
              />
              {error && (
                <Alert alertType="error" header={'Error signing for this assurance'}>
                  <p>The signature cannot be accepted because the password is invalid.</p>
                </Alert>
              )}
              <ButtonField
                isDisabled={!confirmation || _.isEmpty(password)}
                buttonText="Sign"
                color="blue"
                handleClick={handleClick}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      );
    }
    return null;
  };

  render() {
    const {dataToRender, allTitles, loading} = this.state;
    const {id, header, headerSize, readOnly, guidance} = this.props;
    return (
      <Segment basic id={id}>
        {header && <Header as={headerSize || 'h3'} content={header} />}
        {guidance && (
          <Alert
            header="Instructions"
            content={guidance}
            type="info"
            dismissable={false}
          />
        )}
        <Form>
          {loading && <Loader inline="centered" active content="Loading" />}
          {_.map(dataToRender, (item, index) => {
            const burdenStatement = BURDEN_STATEMENTS[_.get(allTitles, index)];
            return (
              <React.Fragment key={index}>
                {burdenStatement && <BurdenStatement {...burdenStatement} />}
                {ReactHtmlParser(item)}
                <br />
                {!readOnly && this.passwordConfirmation(index)}
              </React.Fragment>
            );
          })}
        </Form>
      </Segment>
    );
  }
}

export default connectDynamic(DynamicAssuranceAndCertifications);
